"use client";
import { Stack } from "@chakra-ui/react";
import { scrollToElement } from "@/utils/scrollToElement";
import { Button } from "@/elements";
import CardsList from "@/components/cardsList";
import { LBGhoverEffect } from "styles/hoverPresets";
import { HOSTED_GRAFANA_FEATURES } from "./constants";

const Features = () => {
  return (
    <Stack gap={12}>
      <CardsList
        columns={{ base: 1, sm: 2, md: 4 }}
        title={HOSTED_GRAFANA_FEATURES.title}
        list={HOSTED_GRAFANA_FEATURES.list}
        spacing={{ base: 8, md: 12 }}
        hoverEffect
        hover={LBGhoverEffect}
      />
      <Button
        variant={"ideal"}
        onClick={() => scrollToElement("contact-us", 120)}
        alignSelf={"center"}
        p={6}
      >
        Ready To Try Our Hosted Grafana?
      </Button>
    </Stack>
  );
};

export default Features;
